import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Filter, IAllHisFilter, EmptyAllHisFilter } from "./Filter";
import { format } from "date-fns";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface IAllocationHistory {
    req_Id?: number,
    sales_Person_Id?: number,
    sales_Person_Name?: string,
    recruiter_Id?: number,
    recruiter_Name?: string,
    req_Diff_Minutes?: number,
    req_PostedDateTime?: Date,
    created_At?: Date,
    vendor_Name?: string,
    consultant_Name?: string
}

export const AllocationHistory = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllocationHistory>, loading: boolean });
    const [allHisFilter, setAllHisFilter] = useState<IAllHisFilter>(EmptyAllHisFilter);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const [filter, setFilter] = useState(false);
    const hideFilterDialog = () => {
        setFilter(false);
    };

    useEffect(() => {
        loadTableData();
    }, [allHisFilter]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("AllocateRequirement_mast/history", "GET", null, `filter=${JSON.stringify(allHisFilter)}`, toast);
        if (response) {
            const data: Array<IAllocationHistory> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const rightToolbarTemplate = () => {
        return (
            permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Allocation History</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const req_PostedDateTime = (rowData: IAllocationHistory) => {
        let date;
        if (rowData.req_PostedDateTime) date = format(new Date(rowData.req_PostedDateTime), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const created_At = (rowData: IAllocationHistory) => {
        let date;
        if (rowData.created_At) date = format(new Date(rowData.created_At), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter allHisFilter={allHisFilter} setAllHisFilter={setAllHisFilter} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="65vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="req_Id" header="Req ID" />
                <Column field="recruiter_Name" header="Recruiter" sortable />
                <Column field="sales_Person_Name" header="Sales Manager" sortable />
                {/* <Column field="req_PostedDateTime" header="Posted Date" body={req_PostedDateTime} /> */}
                <Column field="req_PostedDateTime" header="Posted Date" body={(rowData :any) =>safeFormatDate(rowData.req_PostedDateTime, "dd/MM/yyyy", DateFormat)} />
                {/* <Column field="created_At" header="Created At" body={created_At} /> */}
                <Column field="created_At" header="Created At" body={(rowData : any) => safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat)} />
                <Column field="vendor_Name" header="Vendor Name" />
                <Column field="consultant_Name" header="Consultant Name" />
            </DataTable>
            {/* <Filter open={filter} hideDialog={hideFilterDialog} setAllHisFilter={setAllHisFilter} toast={toast} /> */}
            <Toast ref={toast} />
        </>
    );
}
